<div class="row">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Consumo Poncho (ml/sc)</mat-label>
                <input matInput id="txtConPoncho" #txtConPoncho maxlength="10" formControlName="consumo_poncho"
                  currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtConPoncho.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.consumo_poncho)}}
                </mat-error>
              </mat-form-field>
            </div>
            <!-- <div class="col-lg col-md">
                          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                              floatLabel="{{formFieldFloatLabel}}">
                              <mat-label class="InputLabelColor">Consumo Cruiser (ml/sc)</mat-label>
                              <input matInput id="txtConCruiser" #txtConCruiser maxlength="10"
                                  formControlName="consumo_cruiser" currencyMask readonly class="InputBlockColor">
                              <i matSuffix class="{{iconDisableField}}"></i>
                              <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                              <mat-hint align="end">{{txtConPoncho.value.length}} / 10</mat-hint>
                              <mat-error>{{hasErrorFormControl(formulario.controls.consumo_cruiser)}}
                              </mat-error>
                          </mat-form-field>
                      </div> -->
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Consumo Dermacor (ml/sc)</mat-label>
                <input matInput id="txtConDermacor" #txtConDermacor maxlength="10" formControlName="consumo_dermacor"
                  currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtConDermacor.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.consumo_dermacor)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <!--  <div class="col-lg-6 col-md-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Consumo Derosal (ml/sc)</mat-label>
                                <input matInput id="txtConDerosal" #txtConDerosal maxlength="10"
                                    formControlName="consumo_derosal" currencyMask readonly class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtConDerosal.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.consumo_derosal)}}
                                </mat-error>
                            </mat-form-field>
                        </div>-->
            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Consumo Talkum Gloss (g/kg)</mat-label>
                <input matInput id="txtConTalkGloss" #txtConTalkGloss maxlength="10"
                  formControlName="consumo_talkum_gloss" currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtConTalkGloss.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.consumo_talkum_gloss)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Consumo Redigo (ml/sc)</mat-label>
                <input matInput id="txtConRedigo" #txtConRedigo maxlength="10" formControlName="consumo_redigo"
                  currencyMask readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtConRedigo.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.consumo_redigo)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg-4 col-md-4">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                      floatLabel="{{formFieldFloatLabel}}">
                      <mat-label class="InputLabelColor">Criado por</mat-label>
                      <input matInput id="txtCriadoPor" #txtCriadoPor maxlength="40"
                          formControlName="criado_por" readonly class="InputBlockColor">
                      <i matSuffix class="{{iconDisableField}}"></i>
                      <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                      <mat-hint align="end">{{txtCriadoPor.value.length}} / 40</mat-hint>
                      <mat-error>{{hasErrorFormControl(formulario.controls.criado_por)}}
                      </mat-error>
              </mat-form-field>
          </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>